module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f70d476f0b0ef124a4743a7e96bc4855.png";